// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"118":"b7e27b0add176b1f","292":"4ccff91ec0d091c2","337":"e99007de013690be"}[chunkId] + ".js";
};